import React, { memo } from 'react';

export const ParagraphIcon = memo(() => (
  <div className="flex flex-col gap-3 w-24">
    <div className="h-[6px] bg-white/15 rounded-md w-full" />
    <div className="h-[6px] bg-white/15 rounded-md w-full" />
    <div className="h-[6px] bg-white/15 rounded-md w-full" />
    <div className="h-[6px] bg-white/15 rounded-md w-[60%]" />
  </div>
));
